import type { RouteObject } from 'react-router-dom'

import { preparationLoader } from './preparation/Preparation.loader'
import { SHIPMENT_PREPARATION_URL } from './preparation/Preparation.navigator'
import PreparationPage from './preparation/Preparation.page'
import { shipmentLoader } from './Shipment.loader'
import { SHIPMENT_URL } from './Shipment.navigator'

import ShipmentPage from './Shipment.page'

export const shipmentRoutes: RouteObject[] = [
  {
    id: '(Shipment) Start Page',
    path: SHIPMENT_URL,
    element: <ShipmentPage />,
    loader: shipmentLoader
  },
  {
    id: '(Shipment) Preparation',
    path: SHIPMENT_PREPARATION_URL,
    element: <PreparationPage />,
    loader: preparationLoader
  }
]
